module.exports = __webpack_public_path__ + "pc/img/modal_00.b572adb6.png";